import React from "react";
import PropTypes from "prop-types";

// ant design
import { Form, Select } from "antd";
import TextNameAuthEvaluated from "../common/TextNameAuthEvaluated";
import { ethnicities } from "../../../utils/constants";

const FormItemSelectEthnicity = ({
  label,
  name,
  validateStatus,
  help,
  hasFeedback,
  mode,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      validateStatus={validateStatus}
      help={help}
      hasFeedback={hasFeedback}
    >
      <Select
        mode={mode}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          optionA.children
            .toString().toLowerCase()
            .localeCompare(optionB.children.toString().toLowerCase())
        }
      >
        {ethnicities.map((e) => (
          <Select.Option key={e} value={e}>
            {/* overkill permissions check, disabled until further discussion */}
            {e}
            {/* <TextNameAuthEvaluated entity={ethnicity} /> */}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

FormItemSelectEthnicity.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  help: PropTypes.string,
  validateStatus: PropTypes.string,
  hasFeedback: PropTypes.bool,
  mode: PropTypes.string,
};

export default FormItemSelectEthnicity;
